// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YMv2D,.JWJoF{align-items:center;display:flex;margin:0 .5rem!important;overflow:hidden}.YMv2D .zZo0R,.JWJoF .zZo0R{align-items:center;background-color:#fff;color:#000000de;display:flex!important;float:right;height:1.875rem;justify-content:center;line-height:.65rem!important;margin:-.5rem -.75rem -.5rem .5rem;opacity:1!important;padding:0 .5rem}.YMv2D{margin:0 0 0 .5rem!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rangeLabel": `YMv2D`,
	"versionLabel": `JWJoF`,
	"versionLabelDetail": `zZo0R`
};
module.exports = ___CSS_LOADER_EXPORT___;
